import React from "react";

const PHONE_REGEX = /(\+?\d[\d\s\-()]{7,}\d)/g;

function formatPhoneForWhatsApp(raw: string): string {
  return raw.replace(/[^\d]/g, "");
}

export function linkifyWhatsApp(text: string): React.ReactNode[] {
  const parts = text.split(PHONE_REGEX);
  return parts.map((part, i) => {
    if (PHONE_REGEX.test(part)) {
      PHONE_REGEX.lastIndex = 0;
      const formatted = formatPhoneForWhatsApp(part);
      return (
        <a
          key={i}
          href={`https://api.whatsapp.com/send/?phone=${formatted}`}
          target="_blank"
          rel="noopener noreferrer"
          className="underline hover:opacity-80 cursor-pointer"
        >
          {part}
        </a>
      );
    }
    return part;
  });
}
